// extracted by mini-css-extract-plugin
module.exports = {"modal":"index_modal__2wfOT"};